export const ccInfoTranslations = {
  'en': {
    'endingIn': 'ending in {lastFour}',
    'expirationDateText': 'Expires {expiration}',
    'expiringSoonText': 'Expires {expiration}',
    'expiredText': 'Expired {expiration}'
  },
  'es': {
    'endingIn': 'terminando en {lastFour}',
    'expirationDateText': 'vencimiento: {expiration}',
    'expiringSoonText': 'vencimiento: {expiration}',   
    'expiredText': 'venció: {expiration}'
  }
};
